import { GroupBonusCelebration } from "@ec2/ui";
import { useT } from "@ec2/i18n/react";
import type { GroupBonus } from "@ec2/contracts";

/**
 * The group-bonus money moment (docs/07 addendum): rendered AFTER the crossing
 * quest's own celebration finishes (§5: one celebration at a time) — the
 * caller swaps it in on the first celebration's action.
 */
export function GroupBonusView({ bonus, onDone }: { bonus: GroupBonus; onDone: () => void }) {
  const t = useT();
  return (
    <GroupBonusCelebration
      title={t("ec2.group.celebration.title")}
      groupName={bonus.groupName}
      amount={bonus.bonusBucks}
      amountLabel={t("ec2.celebration.earned", { amount: bonus.bonusBucks })}
      actionLabel={t("ec2.celebration.backToQuests")}
      onAction={onDone}
    />
  );
}
